import { Offcanvas } from "react-bootstrap";
import { FaBehance, FaDiscord, FaDribbble, FaFacebook, FaFacebookMessenger, FaFigma, FaGithub, FaGitlab, FaInstagram, FaLine, FaLinkedin, FaPinterest, FaQuora, FaReddit, FaShopify, FaSkype, FaSlack, FaSnapchat, FaSoundcloud, FaSpotify, FaStackOverflow, FaTelegram, FaThreads, FaTumblr, FaTwitter, FaViber, FaWeixin, FaWhatsapp, FaWordpress, FaXTwitter, FaYoutube } from "react-icons/fa6";

export const ICONS = [
  { name: "Whatsapp", component: FaWhatsapp, color: "#25D366" },
  { name: "Instagram", component: FaInstagram, color: "#E4405F" },
  { name: "Facebook", component: FaFacebook, color: "#1877F2" },
  { name: "Messenger", component: FaFacebookMessenger, color: "#00B2FF" },
  { name: "Linkedin", component: FaLinkedin, color: "#0A66C2" },
  { name: "Twitter", component: FaTwitter, color: "#1DA1F2" },
  { name: "X", component: FaXTwitter, color: "#000000" },
  { name: "Youtube", component: FaYoutube, color: "#FF0000" },
  { name: "Snapchat", component: FaSnapchat, color: "#FFFC00" },
  { name: "Telegram", component: FaTelegram, color: "#0088cc" },
  { name: "Pinterest", component: FaPinterest, color: "#BD081C" },
  { name: "Reddit", component: FaReddit, color: "#FF4500" },
  { name: "Discord", component: FaDiscord, color: "#5865F2" },
  { name: "Slack", component: FaSlack, color: "#4A154B" },
  { name: "Tumblr", component: FaTumblr, color: "#35465C" },
  { name: "Viber", component: FaViber, color: "#7360F2" },
  { name: "Wechat", component: FaWeixin, color: "#09B83E" },
  { name: "Line", component: FaLine, color: "#00C300" },
  { name: "Skype", component: FaSkype, color: "#00AFF0" },
  { name: "Quora", component: FaQuora, color: "#B92B27" },
  { name: "Threads", component: FaThreads, color: "#000000" },
  { name: "Github", component: FaGithub, color: "#000000" },
  { name: "Gitlab", component: FaGitlab, color: "#FC6D26" },
  { name: "Stackoverflow", component: FaStackOverflow, color: "#F48024" },
  { name: "Dribbble", component: FaDribbble, color: "#EA4C89" },
  { name: "Behance", component: FaBehance, color: "#1769FF" },
  { name: "Figma", component: FaFigma, color: "#F24E1E" },
  { name: "Spotify", component: FaSpotify, color: "#1DB954" },
  { name: "Soundcloud", component: FaSoundcloud, color: "#FF5500" },
  { name: "Wordpress", component: FaWordpress, color: "#21759B" },
  { name: "Shopify", component: FaShopify, color: "#96BF48" },
];

const SocialIconList = ({ show, hide, title, onSelect }) => {

  const handleSelect = (iconName, color) => {
    onSelect?.(iconName, color);
    hide();
  };

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 7,
            flexWrap: "wrap",
            overflowY: "auto",
            padding: 5,
          }}
        >
          {ICONS.map(({ name, component: Icon, color }) => (
            <div
              key={name}
              onClick={() => handleSelect(name, color)}
              className="text-center"
              style={{
                cursor: "pointer",
                fontSize: 28,
                padding: 12,
                borderRadius: 8,
                transition: "0.2s",
              }}
            >
              <Icon color={color} />
              <div style={{fontSize: 11}}>{name}</div>
            </div>
          ))}
        </div>

      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default SocialIconList;